module.exports = __webpack_public_path__ + "assets/img/img51.d54503c9.png";